import * as _ from 'underscore';

import { IConnectedViewInfo, IMetricInfo } from '../models/IMetricInfo';
import { IUserInfo } from '../models/IUserInfo';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { IConnectedView, IMetric, IMetricDetail } from '../ServerApi/types/IMetric';
import { IMetricUsageInfo } from '../ServerApi/types/IUsageInfo';
import { MapperHelper } from './MapperHelper';
import { ProjectMapper } from './ProjectMapper';
import { UserMapper } from './UserMapper';

export module MetricMapper {
  const M = MapperHelper;

  export function map(
    serverApiMetrics: IMetric[],
    users: _.Dictionary<IUserInfo>,
    projects: _.Dictionary<INamedItemInfo>,
    connectedViews: _.Dictionary<IConnectedViewInfo>,
    usageInfoMaxValues?: IMetricUsageInfo,
    favoriteMetrics: _.Dictionary<any> = {}
  ): IMetricInfo[] {
    return serverApiMetrics.map((m: IMetric) => {
      return mapOne(m, users[m.ownerId], projects[m.projectId], connectedViews[m.connectedViewPath], usageInfoMaxValues, !!favoriteMetrics[m.id]);
    });
  }

  export function mapOne(
    metric: IMetric,
    owner?: IUserInfo,
    project?: INamedItemInfo,
    connectedView?: IConnectedViewInfo,
    usageInfoMaxValues?: IMetricUsageInfo,
    favorite?: boolean
  ): IMetricInfo {
    return {
      createdAt:                    M.toDate(metric.createdAt),
      updatedAt:                    M.toDate(metric.updatedAt),
      suspended:                    metric.suspended,
      description:                  metric.description,
      id:                           metric.id,
      name:                         metric.name,
      owner:                        UserMapper.mapOne(owner),
      favorite:                     favorite,
      contentType:                  'metric',
      tags:                         M.sortTags(metric.tags),
      connectedView:                connectedView,
      project:                      project,
      usageInfo:                    metric.usageInfo || <IMetricUsageInfo>{},
      usageInfoMaxValues:           usageInfoMaxValues || <IMetricUsageInfo>{},
    };
  }

  export function mapDetail(
    metric: IMetricDetail
  ): IMetricInfo {
    return {
      createdAt:                    M.toDate(metric.createdAt),
      updatedAt:                    M.toDate(metric.updatedAt),
      suspended:                    metric.suspended,
      description:                  metric.description,
      id:                           metric.id,
      name:                         metric.name,
      owner:                        UserMapper.mapOne(metric.owner),
      favorite:                     metric.favorite,
      contentType:                  'metric',
      tags:                         M.sortTags(metric.tags),
      connectedView:                (metric.connectedViewViewModel && mapOneConnectedView(metric.connectedViewViewModel)),
      project:                      ProjectMapper.mapName(metric.project)
    };
  }

  export function mapConnectedViews(
    serverApiConnectedViews: IConnectedView[]
  ): IConnectedViewInfo[] {
    return serverApiConnectedViews.map((cv: IConnectedView) => mapOneConnectedView(cv));
  }

  export function mapOneConnectedView(
    connectedView: IConnectedView
  ): IConnectedViewInfo {
    return {
      id:                           connectedView.id,
      name:                         connectedView.name,
      isViewModified:               connectedView.isViewModified,
      path:                         connectedView.path,
      thumbnailUrl:                 connectedView.thumbnailUrl,
      type:                         connectedView.type
    };
  }

  export function mapFromCRASS(metric: any): IMetricInfo{
    return {
      createdAt:                    M.toDate(metric.createdTime),
      updatedAt:                    M.toDate(metric.modifiedTime),
      suspended:                    metric.suspendState,
      description:                  metric.description,
      id:                           metric.id + '',
      name:                         metric.title,
      favorite:                     false,
      contentType:                  'metric',
      tags:                         M.sortTags(metric.tags),
      connectedView:                null,
      project:                      null,
      owner: {
        id: metric.ownerId + '',
        displayName: metric.ownerName || '',
        username: metric.ownerName || '',
        domainName: metric.ownerDomain,
        isHiddenInternalUser: false
      },
      usageInfo:                    <IMetricUsageInfo>{},
      usageInfoMaxValues:           <IMetricUsageInfo>{}
    };
  }
}
